import { render, staticRenderFns } from "./PointGmoneyForm.vue?vue&type=template&id=bf7b3d6a"
import script from "./PointGmoneyForm.vue?vue&type=script&lang=js"
export * from "./PointGmoneyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports